<template>
  <div class="footer-wrap">
    <section id="footer">
      <div class="wrapper">
        <!-- 상단: 로고 + 바로가기 -->
        <div class="top-wrapper">
          <img
            class="logo"
            alt="KP Hansuk Chemicals"
            src="https://lab-manager-store.s3.ap-northeast-2.amazonaws.com/seller/products/3/log.png"
          />
          <ul class="links">
            <li @click="onRouteCompany">회사소개</li>
            <li @click="onRouteNotice">공지사항</li>
            <li @click="onRouteFAQ">자주묻는질문</li>
            <li class="strong" @click="onRouteTerms">이용약관</li>
            <li class="strong" @click="onRoutePrivacy">개인정보처리방침</li>
            <li @click="onRouteService">고객센터</li>
          </ul>
        </div>

        <!-- 중간: 고객 지원 -->
        <div class="middle-wrapper">
          <div class="col call">
            <span class="label">고객센터</span>
            <b class="number">02-799-3170</b>
            <p>상담시간 평일 10:00 ~ 17:00</p>
            <p>Off-time 12:00 ~ 13:00 (토/일/공휴일 휴무)</p>
          </div>
          <div class="col support">
            <span class="label">문의</span>
            <p><em>채팅 상담</em> 우측 하단 '채팅 상담' 버튼</p>
            <p>
              <em>이메일</em>
              <a href="mailto:lab@lab-manager.com">lab@lab-manager.com</a>
            </p>
          </div>
          <div class="col about">
            <span class="label">LAB MANAGER STORE</span>
            <b class="tagline">실험에 필요한 모든 것을<br />가장 저렴하게</b>
          </div>
        </div>

        <!-- 하단: 사업자 정보 -->
        <div class="bottom-wrapper">
          <p>
            KP한석화학(주)<i></i>대표자: 서귀석<i></i>사업자등록번호:
            106-81-48000<i></i>통신판매업신고: 제 2025-서울용산-0936 호
          </p>
          <p>
            주소: 서울시 용산구 이촌로 166(이촌동)<i></i>이메일:
            lab@lab-manager.com
          </p>
          <p class="copyright">
            COPYRIGHT © 2025 KP Hansuck Chemicals Co., Ltd. All rights
            reserved.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageName from "@/utils/define/PageName";

export default {
  name: "Footer",
  methods: {
    onRouteCompany() {
      window.location.href = "https://www.koreapetroleum.com/";
    },
    onRouteNotice() {
      this.$router
        .push({
          name: PageName.CsCenter.NoticeManagement,
        })
        .catch(() => {});
    },
    onRouteFAQ() {
      this.$router
        .push({
          name: PageName.CsCenter.QuestionManagement,
        })
        .catch(() => {});
    },
    onRouteTerms() {
      window.location.href =
        "https://smartjack.notion.site/15d6730042364ea1a511ab382192d3f7";
    },
    onRoutePrivacy() {
      window.location.href =
        "https://smartjack.notion.site/d41a74be81124ea3a9fb5f91409d490f";
    },
    onRouteService() {
      this.$router
        .push({
          name: PageName.CsCenter.QuestionManagement,
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
$INK: #161616;
$YELLOW: #fabf14;

/* 본문보다 튀지 않도록 밝은 회색 바탕. 노랑은 작은 라벨에만 쓴다. */
#footer {
  width: 100%;
  margin-top: 40px;
  background: #f7f8fa;
  border-top: 1px solid #eceef1;
  color: #6b7280;

  .wrapper {
    padding: 34px 0 32px;
  }

  /* 상단: 로고 + 링크 */
  .top-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e6e8ec;

    .logo {
      height: 36px;
    }

    .links {
      display: flex;
      flex-wrap: wrap;
      gap: 6px 26px;
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        font-size: 14px;
        font-weight: 500;
        color: #4b5563;
        cursor: pointer;

        &:hover {
          color: $INK;
          text-decoration: underline;
        }
        &.strong {
          font-weight: 800;
          color: $INK;
        }
      }
    }
  }

  /* 중간: 고객 지원 */
  .middle-wrapper {
    display: grid;
    grid-template-columns: 1.1fr 1.2fr 1fr;
    gap: 40px;
    padding: 26px 0;
    border-bottom: 1px solid #e6e8ec;

    .col {
      .label {
        display: inline-block;
        margin-bottom: 12px;
        padding: 2px 9px;
        border-radius: 10px;
        background: $YELLOW;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 0.06em;
        color: $INK;
      }
      p {
        margin: 0 0 4px;
        font-size: 13px;
        line-height: 1.6;
      }
    }

    .call {
      .number {
        display: block;
        margin-bottom: 8px;
        font-size: 26px;
        font-weight: 800;
        letter-spacing: -0.01em;
        color: $INK;
      }
    }

    .support {
      p {
        em {
          display: inline-block;
          min-width: 64px;
          font-style: normal;
          font-weight: 700;
          color: #374151;
        }
        a {
          color: #4b5563;
          &:hover {
            color: $INK;
            text-decoration: underline;
          }
        }
      }
    }

    .about {
      .tagline {
        display: block;
        font-size: 16px;
        font-weight: 800;
        line-height: 1.5;
        color: #374151;
      }
    }
  }

  /* 하단: 사업자 정보 */
  .bottom-wrapper {
    padding-top: 20px;
    font-size: 12px;
    line-height: 1.8;
    color: #9ca3af;

    p {
      margin: 0;
    }
    /* 항목 구분선 */
    i {
      display: inline-block;
      width: 1px;
      height: 10px;
      margin: 0 10px;
      background: #d1d5db;
    }
    .copyright {
      padding-top: 10px;
      color: #b0b5bd;
    }
  }
}
</style>
